// "six" rather than "6", for a count the page states in a sentence.
//
// It exists because /services says how many washes there are in four places
// (the heading, the line under it, the table's caption and the final CTA) and
// the page no longer decides that number: the database does. A sentence with
// "six" typed into it is the same class of bug as a list with six names typed
// into it, and this is a much smaller fix than rewriting the sentences to
// avoid counting.
//
// Past twelve it falls back to the digits, which is the point at which a
// comparison table is the wrong shape anyway.
const WORDS = [
  'no',
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
  'ten',
  'eleven',
  'twelve'
]

export const numberWord = count => WORDS[count] || String(count)
